module.exports = __webpack_public_path__ + "static/media/introScreenIcon@2x.55fa4dda.png";